import { fromGlobalId, toGlobalId } from 'utils/transformations/graphql'

type ShouldRender =
  | 'invoice'
  | 'disabled-brand-connected'
  | 'disabled-payment-options'
  | 'redirect'
  | null
type CheckLiteRetailerConditionsArgs = {
  paymentProvider: string | null
  joorPayUseReach: boolean
  showInvoicesAutomatically: boolean
  paymentLinkSent: boolean
}

export const checkLiteRetailerConditions = ({
  paymentProvider,
  showInvoicesAutomatically,
  joorPayUseReach,
  paymentLinkSent,
}: CheckLiteRetailerConditionsArgs): ShouldRender => {
  if (
    joorPayUseReach &&
    paymentProvider === 'reach' &&
    !showInvoicesAutomatically &&
    !paymentLinkSent
  ) {
    return 'disabled-payment-options'
  }

  if (
    paymentProvider === null ||
    paymentProvider === 'stripe' ||
    !joorPayUseReach
  ) {
    return 'disabled-brand-connected'
  }

  if (
    joorPayUseReach &&
    paymentProvider === 'reach' &&
    showInvoicesAutomatically
  ) {
    return 'invoice'
  }

  if (
    joorPayUseReach &&
    paymentProvider === 'reach' &&
    !showInvoicesAutomatically &&
    paymentLinkSent
  ) {
    return 'invoice'
  }

  return null
}

export const checkProBrandConditions = ({
  joorPayUseReach,
  paymentProvider,
}: {
  joorPayUseReach: boolean
  paymentProvider: string | null
}) => {
  if (!joorPayUseReach || paymentProvider !== 'reach') {
    return 'disabled'
  }

  if (joorPayUseReach && paymentProvider === 'reach') {
    return 'invoice'
  }

  return null
}

/**
 * Takes a retailerId in globalId format, checks its type and,
 * if it's not of `RetailerAccount` type it will decoded it and
 * recode it with the `RetailerAccount` as type. needed to make
 * the SendPaymentRequest modal usable in both the order list page
 * and OR2023 without having to care about the type of the globalid
 * that it receives
 */
export const convertGlobalIdToRetailerAccount = (
  retailerId?: string | null,
) => {
  if (retailerId) {
    const { type, id } = fromGlobalId(retailerId)
    if (
      type !== 'RetailerAccount' &&
      type?.toLowerCase()?.includes('retailer')
    ) {
      return toGlobalId('RetailerAccount', id) ?? ''
    }
    return retailerId
  }

  return ''
}
